/**
 * Cores/labels do cockpit Clean Core. Reusa os primitivos compartilhados do
 * app (cleanCoreLevelMeta / CLEAN_CORE_BADGE_COLOR de @/lib/wricef-status,
 * CONVERSION_LABELS / CONVERSION_COLORS de @/types/wricef) e acrescenta só o
 * que é específico desta tela: as barras sólidas por nível e os modelos de
 * extensibilidade.
 */

import type { CleanCoreLevel, ExtensibilityTarget } from "@/types/wricef";

export {
  cleanCoreLevelMeta,
  CLEAN_CORE_BADGE_COLOR,
} from "@/lib/wricef-status";
export { CONVERSION_LABELS, CONVERSION_COLORS } from "@/types/wricef";

// Label curto por nível, pra legendas/títulos das barras.
export const LEVEL_LABEL: Record<CleanCoreLevel, string> = {
  A: "A — cloud-ready",
  B: "B — classic on-stack",
  C: "C — side-by-side / mixed",
  D: "D — outside clean core",
};

// Cor sólida das barras empilhadas por nível (famílias coerentes com os badges
// de CLEAN_CORE_BADGE_COLOR: A=ok/emerald, B/C=warn/amber, D=danger/red).
export const LEVEL_BAR: Record<CleanCoreLevel, string> = {
  A: "bg-emerald-500",
  B: "bg-amber-500",
  C: "bg-orange-500",
  D: "bg-red-500",
};

// ---------------------------------------------------------------------------
// Modelos de extensibilidade (como estender no S/4)
// ---------------------------------------------------------------------------

export interface ExtensibilityMeta {
  label: string;
  // descrição curta da estratégia
  hint: string;
  // cor sólida da barra
  bar: string;
  // classes do badge (fundo + texto)
  badge: string;
}

export const EXTENSIBILITY_META: Record<ExtensibilityTarget, ExtensibilityMeta> =
  {
    key_user: {
      label: "Key User",
      hint: "In-app, no code — custom fields, BRF+ logic, layouts. Least effort, fully cloud-ready.",
      bar: "bg-sky-500",
      badge: "bg-sky-100 text-sky-700 border-sky-200",
    },
    side_by_side: {
      label: "Side-by-Side",
      hint: "Decoupled on BTP via released APIs — reports, integrations, apps.",
      bar: "bg-violet-500",
      badge: "bg-violet-100 text-violet-700 border-violet-200",
    },
    developer: {
      label: "Developer",
      hint: "On-stack cloud with ABAP RAP — when core proximity is required. Requires ABAP Cloud skills.",
      bar: "bg-teal-500",
      badge: "bg-teal-100 text-teal-700 border-teal-200",
    },
  };
